// Web-safe mock for react-native-config
// This mock now pulls variables directly from the .env file via Webpack's DefinePlugin
// Ensure that your local .env file contains all necessary configuration keys.

export default process.env;
